import { motion } from 'framer-motion';
import { sermons } from '../../../mocks/sermons';

const RecentSermons = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  
  const recentSermons = [...sermons]
    .filter((sermon) => new Date(sermon.date) <= today)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 3);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-black mb-4">Recent Sermons</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Listen to our latest messages and be inspired by the Word of God
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {recentSermons.map((sermon, index) => (
            <motion.a
              key={sermon.id}
              href={sermon.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group bg-gray-50 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 border border-gray-200"
            >
              <div className="p-8">
                <div className="flex items-center justify-center w-16 h-16 bg-black rounded-lg mb-6 group-hover:bg-blue-600 transition-colors">
                  <i className="ri-mic-line text-3xl text-white"></i>
                </div>
                
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-600 text-xs font-medium rounded-full whitespace-nowrap">
                    {new Date(sermon.date).toLocaleDateString('en-GB', { 
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </span>
                </div>

                <h3 className="text-xl font-semibold text-black mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                  {sermon.title}
                </h3>
                
                <div className="flex items-center text-gray-600 text-sm mb-4">
                  <i className="ri-user-line mr-2"></i>
                  <span>{sermon.speaker}</span>
                </div>

                <div className="flex items-center text-blue-600 font-medium text-sm group-hover:translate-x-2 transition-transform">
                  <span className="whitespace-nowrap">Listen Now</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center"
        >
          <a
            href="https://rare-humor-098.notion.site/2da621589890431db6da05235c1d1261?v=12c48993a83d483096383e6ed3a6a2db"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
          >
            View All Sermons
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default RecentSermons;
